module.exports = __webpack_public_path__ + "static/img/p_20.9c0db95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_20.jpg
// module id = 9T4m
// module chunks = 9